import { Component, HostBinding, Input } from '@angular/core';
import { EaVariant } from '@app/components/pr-display';
import { PrTabsItem } from './model/pr-tabs';

@Component({
  selector: 'pr-tabs-2',
  templateUrl: './pr-tabs.component.html',
  styleUrls: ['./pr-tabs.component.scss'],
  standalone: false,
})
export class PrTabsComponent {
  @Input() tabs: PrTabsItem[];
  @Input() withPlus: boolean = true;
  @Input() variant: EaVariant;

  @HostBinding('class.pills') get isPills(): boolean {
    return this.variant === EaVariant.pills;
  }
}
